import NiceModal, {
  type NiceModalHocProps,
  useModal
} from "@ebay/nice-modal-react";
import React, {
  type FC,
  useCallback,
  useEffect,
  useMemo,
  useState
} from "react";
import "../../../app/17_JetpackOnboarding/components/styles.scss";
import EventsSelector from "./component/EventsSelector";
import {
  updateJetpackConfigThunk,
  useJetpackConfigSelector
} from "../../../redux/jetpackConfig";
import KC_Modal_2 from "../../../designsystem/KC_Modal/KC_Modal_2";
import KC_Heading3 from "../../../designsystem/typography/KC-Heading/KC_Heading3";
import { ProgressBar } from "../../common/ProgressBar/ProgressBar";
import "./styles.scss";
import { tt } from "../../../utils/i18n/i18n";
import { useDispatch } from "react-redux";
import { Config } from "kadow-jetpack-model";
import { useAccountToDisplaySelector } from "../../../redux/actions/user";

interface Props {
  title?: string;
  step: CreateAnimationStep;
  includeGamesOfChance: boolean;
  includePerformanceGames: boolean;
}

export enum CreateAnimationStep {
  AnimationType = 0,
  GameConfig = 1,
  EventConfig = 2
}

const CreateAnimationModal: FC<Props & NiceModalHocProps> =
  NiceModal.create<Props>((props) => {
    const dispatch = useDispatch();
    const { accountToDisplay } = useAccountToDisplaySelector();
    const modal = useModal();
    const jetpackConfig = useJetpackConfigSelector();
    const [step, setStep] = useState<CreateAnimationStep | null>(props.step);

    const handleClose = async () => {
      modal.resolve();
      void modal.hide();
    };

    const handleSubmit = useCallback(
      (newConfig: Config) => {
        dispatch(
          updateJetpackConfigThunk(
            { games: newConfig.games, activeEvents: newConfig.activeEvents },
            accountToDisplay?.trackingID,
            accountToDisplay?.token
          )
        );
        modal.resolve();
        void modal.hide();
      },
      [jetpackConfig]
    );

    const pc = useMemo(() => {
      switch (step) {
        case CreateAnimationStep.AnimationType:
          return 30;
        case CreateAnimationStep.EventConfig:
          return 60;
        case CreateAnimationStep.GameConfig:
          return 80;
        default:
          return 0;
      }
    }, [step]);

    useEffect(() => {
      if (props.step) {
        setStep(props.step);
      }
    }, [props.step]);

    if (jetpackConfig == null) {
      return <></>;
    }

    return (
      <KC_Modal_2
        id="create-animation-modal"
        isOpen={modal.visible}
        onClose={handleClose}
        hideCloseButton={false}
        header={
          <div className="w-100 py-2 px-3">
            <KC_Heading3 text={tt("game")} />
          </div>
        }
      >
        <ProgressBar rate={pc} noRoundedCorners={true} />
        <EventsSelector
          handleSubmit={handleSubmit}
          hideModal={handleClose}
          includePerformanceGames={props.includePerformanceGames}
          includeGamesOfChance={props.includeGamesOfChance}
        />
      </KC_Modal_2>
    );
  });

export default CreateAnimationModal;
